import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextareaAutosize,
} from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  AppraisalRevokedRequest,
  AppraisalTask,
  GetAppraisalModel,
} from "../../../all_Interfaces";
import { UserContext } from "../../../redux/slices/userContextSlice";
import ReplayIcon from "@mui/icons-material/Replay";
import DirectionsIcon from "@mui/icons-material/Directions";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import {
  AppraisalReviewServiceURL,
  TaskmgmtServiceURL,
} from "../../../config/config";
import { ServiceName } from "../../../constants";
import PrintIcon from "@mui/icons-material/Print";
import { AlertDialog } from "../../util/Dialog";
import { wait } from "@testing-library/user-event/dist/utils";
import PrintToPDF from "./print/printToPdf";

type MenuItem = {
  key: number;
  label: string;
  icon: React.ReactElement;
  action: () => void;
};

export const HamburgerMenu = (props: any) => {
  const navigate = useNavigate();
  const [appraisalId, setAppraisalId] = useState<string>("");
  const menuItems: MenuItem[] = [];
  const [loading, setLoading] = useState<boolean>(false);
  const [deleteAppraisalMenu, setDeleteAppraisalMenu] =
    useState<boolean>(false);
  const [deleteAndArchiveAppraisalMenu, setDeleteAndArchiveAppraisalMenu] =
    useState<boolean>(false);
  const [loadRevokeappraisalmenu, setLoadRevokeappraisalmenu] =
    useState<boolean>(false);
  const [loadrecallappraisalmenu, setLoadrecallappraisalmenu] =
    useState<boolean>(false);

  const [printToggle, setPrintToggle] = useState<boolean>(false);
  const [revokeToggle, setRevokeToggle] = useState<boolean>(false);
  const [deleteToggle, setDeleteToggle] = useState<boolean>(false);
  const [deleteAndArchiveToggle, setDeleteAndArchiveToggle] =
    useState<boolean>(false);
  const [recallToggle, setRecallToggle] = useState<boolean>(false);

  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [openDeleteAndArchiveDialog, setOpenDeleteAndArchiveDialog] =
    useState<boolean>(false);
  const [appraisalData, setAppraisalData] = useState<GetAppraisalModel>();
  const [open, setOpen] = useState(false);

  // const childRef = useRef(null);

  // const callChildFunction = () => {
  //   childRef?.current?.childFunction();
  // };

  useEffect(() => {
    // menuItems.push({
    //   key: 1,
    //   label: "Print",
    //   icon: <PrintIcon />,
    //   action: () => {
    //     print();
    //   },
    // });
    setAppraisalId(props.appraisalId);

    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      await getApiCall(
        AppraisalReviewServiceURL + "/appraisals/getbyid/" + props.appraisalId,
        ServiceName.APPRAISALREVIEW
      )
        .then((data: any) => {
          var appraisalData = data.result as GetAppraisalModel;
          setLoadrecallappraisalmenu(
            props.userContext.isAdmin &&
              appraisalData.status != "New" &&
              appraisalData.status != "Posted" &&
              !appraisalData.status.includes("Rejected")
          );
          setLoadRevokeappraisalmenu(
            props.userContext.isAdmin && appraisalData.status === "Posted"
          );
          setDeleteAndArchiveAppraisalMenu(
            props.userContext.isAdmin && appraisalData.showDelete
          );
          setDeleteAppraisalMenu(
            props.userContext.isAdmin && appraisalData.status != "Posted"
          );
          setAppraisalData(data.result);
          console.log(data.result);
        })
        .catch((e: any) => {
          console.log(e);
        })
        .finally(() => {
          console.log("finally ham burger");

          setLoading(false);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const print = () => {
    window.print();
  };

  const fnRecallAppraisal = () => {
    var appraisalDataModel: GetAppraisalModel =
      appraisalData != undefined || appraisalData != null
        ? { ...appraisalData }
        : new GetAppraisalModel();

    if (appraisalData?.workflowId != "00000000-0000-0000-0000-000000000000") {
      var newAppraisalTaskItem = new AppraisalTask();
      newAppraisalTaskItem.appraisalid = appraisalId;
      newAppraisalTaskItem.approver = props.userContext.displayName;
      newAppraisalTaskItem.firstname = props.userContext.firstName;
      newAppraisalTaskItem.lastname = props.userContext.lastName;
      newAppraisalTaskItem.approverEmail = props.userContext.email;
      newAppraisalTaskItem.comments = "";
      newAppraisalTaskItem.workflowId = props.workflowId;

      appraisalDataModel.activeIndex = 0;
      appraisalDataModel.stage = "";
      appraisalDataModel.status = "New";

      recall(appraisalDataModel, newAppraisalTaskItem);
    }else{
      props.isError({ isError: true, message: `Could not be recalled` });
        wait(3000)
        .then(() => {
          props.isError({ isError: false, message: "" });
        });
    }
  };

  const recall = async (
    appraisalDataModel: GetAppraisalModel,
    newAppraisalTaskItem: AppraisalTask
  ) => {
    var promicess: Promise<any>[] = [];
    try {
      props.loading(true);
      promicess = await Promise.all([
        postApiCall(
          TaskmgmtServiceURL + "/Workflows/Terminate",
          newAppraisalTaskItem,
          ServiceName.TASKMANAGEMENTSERVICE
        ),
        postApiCall(
          AppraisalReviewServiceURL + "/appraisals/RecallAppraisal",
          appraisalDataModel,
          ServiceName.APPRAISALREVIEW
        ),
      ]);
    } catch (e) {
      console.log(e);
    } finally {
      props.loading(false);
      Promise.all(promicess).then((data: any) => {
        window.location.reload();
      });
    }
  };

  console.log(menuItems);

  const closeDialog = () => {
    setOpenDeleteDialog(false);
    setOpenDeleteAndArchiveDialog(false);
  };

  const deleteAndArchiveAppraisal = () => {
    var deleteAppraisalsArray: string[] = [];
    deleteAppraisalsArray.push(appraisalId);
    postApiCall(
      AppraisalReviewServiceURL + "/appraisals/DeleteAndArchiveAppraisal",
      deleteAppraisalsArray,
      ServiceName.APPRAISALREVIEW
    )
      .then((data: any) => {
        props.isSuccess({ isSuccess: true, message: "Appraisal has been Deleted" });
        setOpenDeleteAndArchiveDialog(false);
          wait(3000)
          .then(() => {
            props.isSuccess({ isSuccess: false, message: "" });
          });
      })
      .catch((e: any) => {
        props.isError({ isError: true, message: "Appraisal could not be Deleted" });
        setOpenDeleteAndArchiveDialog(false);
          wait(3000)
          .then(() => {
            props.isError({ isError: false, message: "" });
          });
      });
  };

  const enterRevokeToggle = () => {
    wait(500).then(() => {
    setRevokeToggle(true);
    });
  };

  const leaveRevokeToggle = () => {
    wait(500).then(() => {
    setRevokeToggle(false);
    });
  };

  const enterRecallToggle = () => {
    wait(500).then(() => {
    setRecallToggle(true);
    });
  };

  const leaveRecallToggle = () => {
    wait(500).then(() => {
    setRecallToggle(false);
    });
  };

  const enterDeleteToggle = () => {
    wait(500).then(() => {
    setDeleteToggle(true);
    });
  };

  const leaveDeleteToggle = () => {
    wait(500).then(() => {
    setDeleteToggle(false);
    });
  };

  const enterDeleteAndArchiveToggle = () => {
    wait(500).then(() => {
    setDeleteAndArchiveToggle(true);
    });
  };

  const leaveDeleteAndArchiveToggle = () => {
    wait(500).then(() => {
    setDeleteAndArchiveToggle(false);
    });
  };

  const enterPrintToggle = () => {
    wait(500).then(() => {
    setPrintToggle(true);
    });
  };

  const leavePrintToggle = () => {
    wait(500).then(() => {
    setPrintToggle(false);
    });
  };

  return (
    <>
      {
        <AlertDialog
          isOpen={openDeleteDialog}
          handleClose={closeDialog}
          onConfirm={props.deleteAppraisal}
          title={"Confirmation"}
          message={"Are you sure you want to delete this record?"}
        />
      }

      {
        <AlertDialog
          isOpen={openDeleteAndArchiveDialog}
          handleClose={closeDialog}
          onConfirm={deleteAndArchiveAppraisal}
          title={"Confirmation"}
          message={"Are you sure you want to delete this record?"}
        />
      }

      {/* {true &&
        (printToggle ? (
          <PrintToPDF leavePrintTogglee = {leavePrintToggle}/>
          // <Button sx={{textTransform:"none"}}
          //   variant="contained"
          //   sx={{ color: '#263746' }}
          //   size="small"
          //   onMouseLeave={leavePrintToggle}
          // >
          //   Print
          // </Button>
        ) : (
          <IconButton sx={{ color: '#263746' }} onMouseEnter={enterPrintToggle}>
            <PrintIcon />
          </IconButton>
        ))}

      {loadRevokeappraisalmenu &&
        (revokeToggle ? (
          <Button sx={{textTransform:"none"}}
            variant="contained"
            sx={{ color: 'white', backgroundColor:'#263746' }}
            // color="#263746"
            size="small"
            onClick={() => {
              props.openRevokeDialog(true);
            }}
            onMouseLeave={leaveRevokeToggle}
          >
            Revoke
          </Button>
        ) : (
          <IconButton  sx={{ color: '#263746' }} onMouseEnter={enterRevokeToggle}>
            <DirectionsIcon sx={{ transform: "scaleX(-1)" }}/>
          </IconButton>
        ))}

      {loadrecallappraisalmenu &&
        (recallToggle ? (
          <Button sx={{textTransform:"none"}}
            variant="contained"
            sx={{ color: 'white', backgroundColor:'#263746' }}
            size="small"
            onClick={fnRecallAppraisal}
            onMouseLeave={leaveRecallToggle}
          >
            Recall
          </Button>
        ) : (
          <IconButton  sx={{ color: '#263746' }} onMouseEnter={enterRecallToggle}>
            <ReplayIcon />
          </IconButton>
        ))}

      {deleteAppraisalMenu &&
        (deleteToggle ? (
          <Button sx={{textTransform:"none"}}
            variant="contained"
            sx={{ color: 'white', backgroundColor:'#263746' }}
            size="small"
            onClick={() => {
              setOpenDeleteDialog(true);
            }}
            onMouseLeave={leaveDeleteToggle}
          >
            Delete
          </Button>
        ) : (
          <IconButton sx={{ color: '#263746' }} onMouseEnter={enterDeleteToggle}>
            <DeleteForeverIcon />
          </IconButton>
        ))}

      {deleteAndArchiveAppraisalMenu && 
        (deleteAndArchiveToggle ? (
          <Button sx={{textTransform:"none"}}
            variant="contained" 
            sx={{ color: 'white', backgroundColor:'#263746' }}
            size="small"
            onClick={() => {
              setOpenDeleteAndArchiveDialog(true);
            }}
            onMouseLeave={leaveDeleteAndArchiveToggle}
          >
            Delete & Archive
          </Button>
        ) : (
          <IconButton sx={{ color: '#263746' }} onMouseEnter={enterDeleteAndArchiveToggle}>
            <DeleteIcon />
          </IconButton>
        ))} */}

      <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <IconButton
            style={{ fontSize: "100px", paddingTop: -4 }}
            {...bindTrigger(popupState)}
          >
            <ListIcon style={{ fontSize: "60px" }} sx={{ top: 0 }} />
          </IconButton>

          
          <Menu sx={{ fontSize: "small" }} {...bindMenu(popupState)}>
            <MenuItem >
              {/* <PrintIcon fontSize="small" color="action" /> <span>&nbsp;Print</span> */}
              <PrintToPDF/>
            </MenuItem>

            {loadRevokeappraisalmenu && (
              <MenuItem onClick={() => {props.openRevokeDialog(true)}}>
                <DirectionsIcon
                  sx={{ transform: "scaleX(-1)" }}
                  fontSize="small" color="action"
                />{" "}
                <span>&nbsp;Revoke</span>
              </MenuItem>
            )}

            {loadrecallappraisalmenu && (
              <MenuItem onClick={() => fnRecallAppraisal()}>
                <ReplayIcon fontSize="small" color="action"/> <span>&nbsp;Recall Appraisal</span>
              </MenuItem>
            )}

            {deleteAppraisalMenu && (
              <MenuItem onClick={() => {setOpenDeleteDialog(true)}}>
                <DeleteForeverIcon fontSize="small" color="action"/> <span>&nbsp;Delete Appraisal</span>
              </MenuItem>
            )}

            {deleteAndArchiveAppraisalMenu && (
              <MenuItem onClick={() => {setOpenDeleteAndArchiveDialog(true)}}>
                <DeleteIcon fontSize="small" color="action"/> <span>&nbsp;Delete and Archive</span>
              </MenuItem>
            )}
            
           
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
    </>
  );
};
